import React, { Component } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { withNamespaces } from "react-i18next";
import Lightbox from "react-image-lightbox";
import moment from "moment";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import Button from "../../components/Button/Button";
// import PromotedVideoCreate from "./PromotedVideoCreate";
import MemberLoginStatusListing from "./MemberLoginStatusListing";
// import PromotedVideoShow from "./PromotedVideoShow";
import { filterErrorHandler } from "../../hoc/Shared/utility";

import { getMemberLoginStatus } from "../../store/ducks/memberLoginStatus/actions";
import { getDropDown } from "../../store/ducks/banks/actions";

const initialInputState = {
    /* form input value */
    member_login_date: "",
    email: "",
    ipAddress: "",
    fingerPrintId: "",
    browser: "",
    operatingSystem: "",
    city: "",
    region: "",
    postalCode: "",
    start_date: '',
    end_date: '',
    filterRiskAssessment: '',
    filterIPAssessment: '',
};

let memberLoginStatusData = {};
class MemberLoginStatus extends Component {
    state = {
        pageShow: "listing",

        activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
        limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
        sorted: null,
        totalPages: 0,
        totalRecords: 0,
        searchValue: "",
        isOpen: false,

        data: [],
        collidedIPData: [],

        dropDown: [],

        filter: initialInputState,

        currentBusinessAccountId: "",
        loading: true,
        currentImage: "",

        permission: [],
    };

    fetchData() {
        let availablePage = this.state.activePage;

        if (this.state.totalRecords !== 0) {
            availablePage = parseInt(this.state.totalRecords / this.state.limit + 1);
            this.state.activePage >= availablePage && this.setState({ activePage: availablePage });
        }
        Object.keys(this.state.filter).forEach((val) =>
        {
            // listingArr[val] = this.state.filter[val];
            memberLoginStatusData[val] = ((val==='start_date' || val==='end_date') && this.state.filter[val]!=='') ? moment(this.state.filter[val]).format("YYYY-MM-DD HH:mm:ss") : this.state.filter[val];
        });
        memberLoginStatusData.page = this.state.activePage >= availablePage ? availablePage : this.state.activePage;
        memberLoginStatusData.limit = this.state.limit;
        memberLoginStatusData.order = JSON.stringify(this.state.sorted);
        memberLoginStatusData.lang_id = this.props.currentLanguageId;
        memberLoginStatusData.title = this.state.filter.title;
        memberLoginStatusData.status = this.state.filter.status;
        memberLoginStatusData.country_id = this.props.currentCountryId;

        this.props.getMemberLoginStatus(memberLoginStatusData);
    }

    componentDidMount() {
        this.props.getDropDown();
        this.fetchData();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.permission.length === 0 && this.props.currentPermission !== undefined) {
            let promotionPermission = this.props.currentPermission.filter((item) => item.includes("member_login_status_"));
            this.setState({ permission: promotionPermission });
        }

        if (nextProps.member_login_status_data !== this.props.member_login_status_data) {
            if (nextProps.member_login_status_data.data.responseCode === 200) {
                this.setState({
                    loading: false,
                    data: nextProps.member_login_status_data.data.data.memberLoginStatus.row,
                    totalRecords: nextProps.member_login_status_data.data.data.memberLoginStatus.pagination.total_record,
                    totalPages: nextProps.member_login_status_data.data.data.memberLoginStatus.pagination.total_page,
                });
            } else {
                this.setState({ 
                    loading: false,
                    data: [],
                    totalRecords: 0,
                    totalPages: 0 
                }, () => {
                    filterErrorHandler(nextProps.member_login_status_data.data.message);
                });
            }
        }

        if (nextProps.dropDown !== this.props.dropDown) {
            if (nextProps.dropDown.responseCode === 200) {
                this.setState({
                    dropDown: nextProps.dropDown.data,
                });
            } else {
                this.setState({ 
                    dropDown: [] 
                }, () => {
                    filterErrorHandler(nextProps.dropDown.message);
                });
            }
        }

        return true;
    }

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence;

        if (order === "asc") {
            orderSequence = true;
        } else {
            orderSequence = false;
        }

        orderArry[0]["id"] = field;
        orderArry[0]["desc"] = orderSequence;

        this.setState({ sorted: orderArry, loading: true, data: [] }, () => {
            this.fetchData();
        });
    };

    updateStatusPromotionHandler = (event, promotionId) => {
        event.preventDefault();
        Swal.fire({
            title: "",
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            onOpen: () => {
                Swal.showLoading();
            },
        });

        const updatePromotionStatusData = {};
        updatePromotionStatusData.video_id = promotionId;
        updatePromotionStatusData.status = Number(event.target.value);

        this.props.updatePromotedVideoStatus(updatePromotionStatusData);
    };

    updateShowPromotionHandler = (event, promotionId) => {
        event.preventDefault();
        Swal.fire({
            title: "",
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            onOpen: () => {
                Swal.showLoading();
            },
        });
        const updatePromotionShowData = {};
        updatePromotionShowData.promotion_id = promotionId;
        updatePromotionShowData.show = Number(event.target.value);

        this.props.updatePromotionShow(updatePromotionShowData);
    };

    onInputChange(event) {
        let newFilter = Object.assign({}, this.state.filter);
        newFilter[event.target.id] = event.target.value;

        if(event.target.id==='member_login_date')
        {
            const date = (event.target.value!=='') ? event.target.value.split(" - ") : null;
            newFilter['start_date'] = (date) ? date[0] : '';
            newFilter['end_date'] = (date) ? date[1] : '';
        }

        this.setState({
            filter: newFilter,
        });
    }

    refreshHandler = () => {
        this.setState(
            {
                loading: true,
                data: [],
                activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
                limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
                sorted: null
            },
            () => {
                const payload = {
                    ...memberLoginStatusData,
                    ...this.state.filter,
                };
                this.fetchData(payload);
            }
        );
    };

    clearHandler = () => {
        this.setState(
            {
                activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
                filter: initialInputState,
                loading: true,
                data: [],
                limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
                sorted: null,
            },
            () => {
                this.fetchData();
            }
        );
    };

    statusFormatter = (cell, row) => {
        const { t } = this.props;

        let badgeClassName, status;

        if (row.status === 2) {
            badgeClassName = "badge badge-pill badge-danger";
            status = t("transaction.rejected");
        } if (row.status === 1) {
            badgeClassName = "badge badge-pill badge-success";
            status = t("global.approve");
        }else if(row.status === 0) {
            badgeClassName = "badge badge-pill badge-primary";
            status = t("transaction.new-request");
        }
        return <span className={badgeClassName}>{status}</span>;
    };

    actionFormatter = (cell, row) => {
        let editButton, output;

        if (this.state.permission.includes("business_account_edit")) {
            editButton = (
                <Button
                    typeButton="button"
                    classValue="btn btn-sm btn-info"
                    buttonName={<FontAwesomeIcon icon={faPen} />}
                    key={`edit-${row.business_account_id}`}
                    clicked={() => this.changePageHandler("edit", row.business_account_id)}
                />
            );
        }

        output = [editButton];
        return output;
    };

    changePageHandler = (page, businessAccountId) => {
        this.setState({
            pageShow: page,
            currentBusinessAccountId: businessAccountId,
        });
    };

    pageChangeHandler = (activePage) => {
        this.setState({ page: activePage, activePage: activePage, loading: true, data: [] }, () => {
            this.fetchData();
        });
    };

    sizePerPageHandler = (limit) => {
        this.setState({ limit: limit, loading: true, data: [] }, () => {
            this.fetchData();
        });
    };

    postSearchHandler = () => {
        this.setState({ loading: true, data: [], activePage: 1 }, () => {
            this.fetchData();
        });
    };

    onSearchKeyPressHandler = (event) => {
        //Checking press the enter only perform search action
        if (event.key === "Enter") {
            this.setState({ loading: true, data: [], activePage: 1 }, () => {
                this.fetchData();
            });
        }
    };

    videoFormatter = (cell, row) => {
        return <video src={cell} controls width="400" key={`desktop-image-${row.video_id}`}></video>;
    };

    businessAccountImageFormatter = (cell, row) => {
        return (
            <img
                alt=""
                style={{ width: "170px", cursor: "pointer" }}
                src={cell}
                onClick={() => this.setState({ isOpen: true, currentImage: cell })}
                key={`desktop-image-${row.video_id}`}
            />
        );
    };

    IPRiskAssessmentFormatter = (cell, row) => {
        const { t } = this.props;

        let status;

        if (row.ip_risk_assessment === 1) {
            status = t("global._yes");
        } else {
            status = t("global._no");
        }
    
        return <span>{status}</span>;
    }

    riskAssessmentFormatter = (cell, row) => {
        const { t } = this.props;

        let status;

        if (row.risk_assessment === 1) {
            status = t("global._yes");
        } else {
            status = t("global._no");
        }
        return <span>{status}</span>;
    };

    render() {
        const { t } = this.props;
        const columns = [
            {
                text: t("global.no"),
                dataField: "",
                keyField: "ipId",
                formatter: (cell, row, rowIndex) => {
                    //let rowNumber = (this.state.activePage - 1) * this.state.limit + (rowIndex + 1);
                    let reverseRowNumber = this.state.totalRecords - rowIndex - (this.state.activePage - 1) * 10;
                    return <span>{reverseRowNumber}</span>;
                },
                headerStyle: () => {
                    return { width: "60px" };
                },
            },
            {
                text: t("member.email"),
                dataField: "email",
                keyField: "email",
                sort: true,
                onSort: this.onSort,
                // hidden: true
            },
            {
                text: t("member.fingerprint-risk"),
                dataField: "risk_assessment",
                keyField: "riskAssessment",
                sort: true,
                onSort: this.onSort,
                formatter: this.riskAssessmentFormatter,
            },
            {
                text: t("member.ip-risk"),
                dataField: "ip_risk_assessment",
                keyField: "IPRiskAssessment",
                sort: true,
                onSort: this.onSort,
                formatter: this.IPRiskAssessmentFormatter,
            },
            {
                text: t("member.ip-address"),
                dataField: "ip_address",
                keyField: "ipAddress",
                sort: true,
                onSort: this.onSort,
                // hidden: true
            },
            {
                text: t("member.device-type"),
                dataField: "device_type",
                keyField: "deviceType",
                sort: true,
                onSort: this.onSort,
                // hidden: true
            },
            {
                text: t("member.login-time"),
                dataField: "created_at",
                keyField: "loginTime",
                sort: true,
                onSort: this.onSort,
                // hidden: true
            },
            {
                text: t("member.finger-print-id"),
                dataField: "finger_print_id",
                keyField: "fingerPrintId",
                sort: true,
                onSort: this.onSort,
                // hidden: true
            },
            {
                text: t("member.browser"),
                dataField: "browser",
                keyField: "browser",
                sort: true,
                onSort: this.onSort,
                // hidden: true
            },
            {
                text: t("member.browser-version"),
                dataField: "browser_version",
                keyField: "browserVersion",
                sort: true,
                onSort: this.onSort,
                // hidden: true
            },
            {
                text: t("member.operating"),
                dataField: "operating_system",
                keyField: "operatingSystem",
                sort: true,
                onSort: this.onSort,
                // hidden: true
            },
            {
                text: t("member.operating-version"),
                dataField: "operating_system_version",
                keyField: "operatingSystemVersion",
                sort: true,
                onSort: this.onSort,
                // hidden: true
            },
            {
                text: t("member.city"),
                dataField: "city",
                keyField: "city",
                sort: true,
                onSort: this.onSort,
                // hidden: true
            },
            {
                text: t("member.region"),
                dataField: "region",
                keyField: "region",
                sort: true,
                onSort: this.onSort,
                // hidden: true
            },
            {
                text: t("member.postal-code"),
                dataField: "postal_code",
                keyField: "postalCode",
                sort: true,
                onSort: this.onSort,
                // hidden: true
            }
        ];

        return (
            <Auxiliary>
                {this.state.pageShow === "listing" && (
                    <div>
                        {this.state.isOpen && <Lightbox mainSrc={this.state.currentImage} onCloseRequest={() => this.setState({ isOpen: false })} />}
                        <div className="breadcrumb-header justify-content-between">
                            <div className="my-auto">
                                <div className="d-flex">
                                    <h4 className="text-muted mt-1 tx-13 ml-2 mb-0">{t("member.member-login-status")}</h4>
                                </div>
                            </div>
                        </div>

                        <MemberLoginStatusListing
                            city={this.state.filter.city}
                            browser={this.state.filter.browser}
                            filterRiskAssessment={this.state.filter.filterRiskAssessment}
                            filterIPAssessment={this.state.filter.filterIPAssessment}
                            email={this.state.filter.email}
                            fingerPrintId={this.state.filter.fingerPrintId}
                            ipAddress={this.state.filter.ipAddress}
                            region={this.state.filter.region}
                            member_login_date={this.state.filter.member_login_date}
                            postalCode={this.state.filter.postalCode}
                            onInputChange={(event) => this.onInputChange(event)}
                            clearHandler={() => this.clearHandler()}
                            refreshHandler={() => this.refreshHandler()}
                            columns={columns}
                            activePage={this.state.activePage}
                            limit={this.state.limit}
                            totalRecords={this.state.totalRecords}
                            data={this.state.data}
                            order={this.state.sorted}
                            pageChangeHandler={this.pageChangeHandler}
                            sizePerPageHandler={this.sizePerPageHandler}
                            postSearchHandler={this.postSearchHandler}
                            searchPressSubmitHandler={(event) => this.onSearchKeyPressHandler(event)}
                            loading={this.state.loading}
                            permission={this.state.permission}
                            ddBankName={this.state.dropDown.bank_name}
                        />
                    </div>
                )}

                {/* {this.state.pageShow === "create" && (
                    <PromotedVideoCreate refreshHandler={() => this.refreshHandler()} changePageHandler={(page) => this.changePageHandler(page)} />
                )}

                {this.state.pageShow === "show" && (
                    <PromotedVideoShow show_video_id={this.state.currentPromotedVideoId} changePageHandler={(page) => this.changePageHandler(page)} />
                )}
                */}

                {/* {this.state.pageShow === "edit" && (
                    <BusinessAccountEdit
                        show_business_account_id={this.state.currentBusinessAccountId}
                        refreshHandler={() => this.refreshHandler()}
                        changePageHandler={(page) => this.changePageHandler(page)}
                    />
                )}  */}
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = (state) => {
    const { currentUser, memberLoginStatus, bank } = state;

    return {
        currentCountryId: currentUser.data.country_id,
        currentLanguageId: currentUser.data.language_id,
        currentPermission: currentUser.data.permission,
        member_login_status_data: memberLoginStatus.member_login_status_data,
        dropDown: bank.dropDown,
    };
};

const mapDispatchToProps = {
    getMemberLoginStatus,
    getDropDown
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(MemberLoginStatus));
